import React, { createContext, useState, useContext, useEffect } from 'react'
import { fetchAiReadinessData, submitAiReadiness } from '../apis/auth'

export const AiReadinessContext = createContext()



export const AiReadinessProvider = ({ children }) => {
  const [formData, setFormData] = useState({
    schoolName: '', city: '', yourName: '', designation: '', email: '', mobileNumber: '', getCall: false,
  })
  const [questions, setQuestions] = useState([])
  const [userResponses, setUserResponses] = useState([])
  const [step, setStep] = useState(0)
  const [outcomeId, setOutcomeId] = useState(null)
  const [currentIndex, setCurrentIndex] = useState(0)
  const [selectedOptionIndex, setSelectedOptionIndex] = useState(null);

  useEffect(() => {
    fetchQuestions()
  }, [])


  const fetchQuestions = async () => {
    const { success, data } = await fetchAiReadinessData();
    if (success) {
      setQuestions(data?.data || [])
    }
  }

  const goToStep = (stepNumber) => {
    setStep(stepNumber)
  }

  const updateFormData = (key, value) => {
    setFormData(prev => ({
      ...prev,
      [key]: value,
    }))
  }

  const resetFormData = () => {
    setFormData({
      schoolName: '',
      city: '',
      yourName: '',
      designation: '',
      email: '',
      mobileNumber: '',
      getCall: false,
    })
  }

  const addUserResponse = (questionId, selectedOption) => {
    setUserResponses(prev => {
      const existing = prev.findIndex(r => r.question_id === questionId)
      if (existing > -1) {
        const updated = [...prev]
        updated[existing] = { question_id: questionId, selected_option: selectedOption }
        return updated
      }
      return [...prev, { question_id: questionId, selected_option: selectedOption }]
    })
  }

  const resetUserResponses = () => {
    setUserResponses([])
  }


  const jumpToOutcome = (id) => {
    setOutcomeId(id)
    setTimeout(() => { setStep(3) }, 0)
  }

  const submitForm = async () => {
    try {
      const { success, data } = await submitAiReadiness(formData, userResponses)
      if (success && data) {
        // API returns outcome_id directly in data
        const response_id = data?.data?.outcome_details?.outcome_id || "550e8400-e29b-41d4-a716-446655440004"
        jumpToOutcome(response_id)
      } else {
        jumpToOutcome("550e8400-e29b-41d4-a716-446655440004")
      }
    } catch (error) {
      jumpToOutcome("550e8400-e29b-41d4-a716-446655440004")
    }
  }

  const value = {
    formData, setFormData, updateFormData, resetFormData, step,
    setStep, goToStep, questions, userResponses, addUserResponse, resetUserResponses, submitForm,
    outcomeId, currentIndex, setCurrentIndex, selectedOptionIndex, setSelectedOptionIndex
  }

  return (
    <AiReadinessContext.Provider value={value}>
      {children}
    </AiReadinessContext.Provider>
  )
}


export const useAiReadiness = () => {
  const context = useContext(AiReadinessContext)

  if (!context) {
    throw new Error('useAiReadiness must be used within AiReadinessProvider')
  }

  return context
}